<template>
  <div class="user column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div>选择角色：</div>
        <div class="width300">
          <el-select placeholder="请选择角色" style="width: 100%;" filterable clearable v-model="selectRole">
            <el-option v-for="item in roleArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="margin-left20">姓名：</div>
        <div class="width300">
          <el-input placeholder="请输入姓名" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left20" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="flex1"></div>
        <div class="btn-blue width140 btn-height40 margin-left20" @click="clickAdd" v-if="canOperate">
          <el-icon>
            <plus/>
          </el-icon>
          新建
        </div>
      </div>
      <div class="margin-top20">
        <el-table :data="tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column prop="loginName" label="账号" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center"></el-table-column>
          <el-table-column prop="roleStr" label="角色" align="center"></el-table-column>
          <el-table-column label="操作列" align="left" width="400" v-if="canOperate">
            <template #header>
              <div class="margin-left20">操作列</div>
            </template>
            <template #default="scope">
              <div class="row-me center-all">
                <div class="btn-blue width100 btn-height40" @click="clickEdit(scope.row)">
                  <el-icon>
                    <edit/>
                  </el-icon>
                  编辑
                </div>
                <div class="btn-blue width100 btn-height40 margin-left20"
                     @click="clickReset(scope.row)">重置密码
                </div>
                <div class="btn-grey width100 btn-height40 margin-left20"
                     @click="clickDelete(scope.row)">
                  <el-icon>
                    <delete/>
                  </el-icon>
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="margin-top20">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>


    <!-- 新建修改用户 -->
    <el-dialog :title="selectItem.id?'修改用户':'新建用户'" v-model="visibleAdd" width="40%" top="15vh"
               :destroy-on-close="true">
      <div class="padding10">
        <div class="row-me row-center">
          <div><span class="red-star">*</span>账号：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入账号" style="width: 100%;" clearable v-model="selectItem.loginName"
                      :class="{'red-border':showRedBorder&&(selectItem.loginName===''||selectItem.loginName===null)}"
                      maxlength="50">
            </el-input>
          </div>
        </div>
        <div class="row-me row-center margin-top30">
          <div><span class="red-star">*</span>角色：</div>
          <div class="flex1 margin-left5">
            <el-select placeholder="请选择角色" style="width: 100%;" filterable clearable multiple
                       v-model="selectItem.roleIds"
                       :class="{'red-border':showRedBorder&&selectItem.roleIds.length===0}">
              <el-option v-for="item in roleArray" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row-me row-center margin-top30">
          <div><span class="red-star">*</span>密码：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入密码" style="width: 100%;" type="password" clearable
                      v-model="selectItem.password" maxlength="12" minlength="6"
                      :class="{'red-border':showRedBorder&&(!selectItem.useDefaultPassword&&(selectItem.password===''||selectItem.password===null))}"
                      :disabled="isEdit||selectItem.useDefaultPassword" @input="pwdInput">
            </el-input>
          </div>
          <el-checkbox v-model="selectItem.useDefaultPassword" label="使用默认密码" class="margin-left20"
                       @change="pwdChange" :disabled="isEdit">
          </el-checkbox>
        </div>
        <div class="row-me row-center margin-top30">
          <div><span class="red-star-div"></span>姓名：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入姓名" style="width: 100%;" clearable v-model="selectItem.name"
                      maxlength="50">
            </el-input>
          </div>
        </div>
        <div class="row-me row-center flex-end1 margin-top100">
          <div class="btn-blue width140 btn-height40" @click="clickSave">保存</div>
          <div class="btn-grey width140 btn-height40 margin-left20" @click="clickCancel">取消</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      selectRole: '',
      roleArray: [],
      name: '',
      tableData: [],
      visibleAdd: false,
      selectItem: {
        loginName: '',
        roleIds: [],
        password: '',
        useDefaultPassword: false,
        name: '',
      },
      partArray: [],
      isEdit: false,
      showRedBorder: false,
      pageNo: 1,
      total: 0,
      partProps: {
        value: 'id',
        label: 'name',
        children: 'childEmptyNull',
        expandTrigger: 'hover',
        emitPath: false,
      },
      canOperate: false,
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.pageNo = 1
    this.getUserList()
    this.getRoleList()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    pwdChange(e) {
      if (e) {
        this.selectItem.password = ''
      }
    },
    pwdInput() {
      this.selectItem.password = this.selectItem.password.replace(/[^A-Za-z0-9]/g, '')
    },
    //新建
    clickAdd() {
      this.isEdit = false
      this.selectItem = {
        loginName: '',
        roleIds: [],
        password: '',
        useDefaultPassword: false,
        name: '',
      }
      this.showRedBorder = false
      this.visibleAdd = true
    },
    //查询
    clickSearch() {
      this.pageNo = 1
      this.getUserList()
    },
    //清空
    clickClear() {
      this.selectRole = ''
      this.name = ''
      this.pageNo = 1
      this.getUserList()
    },
    //编辑
    clickEdit(item) {
      this.isEdit = true
      this.selectItem = this.$method.deepClone(item)
      let ids = this.selectItem.roles.map(function (item, index) {
        return item.id
      })
      this.selectItem.roleIds = ids
      this.visibleAdd = true
    },
    //重置
    clickReset(item) {
      this.$confirm("您确定要重置密码吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/adminUser/resetUserPassword/' + item.id, {}).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getUserList()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //删除
    clickDelete(item) {
      this.$confirm("您确定要删除账号【" + item.loginName + "】吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/adminUser/delete', [item.id]).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.pageNo = 1
            this.getUserList()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //保存
    clickSave() {
      if (this.selectItem.loginName === '' || this.selectItem.loginName === null || this.selectItem.roleIds
          .length === 0 || (!this.selectItem.useDefaultPassword && (this.selectItem.password === '' || this
          .selectItem.password === null))) {
        this.showRedBorder = true
        return
      }
      if (!this.isEdit && !this.selectItem.useDefaultPassword && (this.selectItem.password.length < 6 || this
          .selectItem.password.length > 12)) {
        this.$message.error('密码长度需在6-12位')
        return
      }
      this.$postRequest('/admin/newUser/saveAdminUser', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleAdd = false
          this.getUserList()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消
    clickCancel() {
      this.visibleAdd = false
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getUserList()
    },
    //获取用户列表
    getUserList() {
      this.$getRequest('/admin/newUser/page', {
        roleId: this.selectRole,
        name: this.name,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          for (let item of res.data.list) {
            item.roleStr = ''
            for (var i = 0; i < item.roles.length; i++) {
              let role = item.roles[i]
              if (i !== 0) {
                item.roleStr += '、' + role.name
              } else {
                item.roleStr += role.name
              }
            }
          }
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取角色下拉
    getRoleList() {
      this.$getRequest('/admin/newRole/new/getAll', {}).then((res) => {
        if (res) {
          this.roleArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.user {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }
}
</style>
